export default function () {
    return (
        <svg width="1135" height="5" viewBox="0 0 1135 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="1135" height="5" fill="url(#paint0_linear_1554_15620)" />
            <defs>
                <linearGradient id="paint0_linear_1554_15620" x1="0" y1="2.5" x2="1135" y2="2.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" stopOpacity="0.1" />
                    <stop offset="0.248939" stopColor="white" />
                    <stop offset="0.524711" stopColor="white" />
                    <stop offset="0.767592" stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.1" />
                </linearGradient>
            </defs>
        </svg>
    );
}
